<template>
  <div class="image-carousel">
    <agile class="main-carousel" ref="main" :options="mainOptions" :as-nav-for="asNavigationForMain">
      <div class="slide" v-for="(slide, index) in imageList" :key="index" :class="`slide--${index}`">
        <img :src="slide" :alt="`Image ${index}`" />
      </div>
      <template slot="prevButton">
        <font-awesome-icon class="icon" role="none" :icon="['far', 'chevron-left']" :style="{ color: iconColor }" />
        <div class="sr-only">Previous</div>
      </template>
      <template slot="nextButton">
        <font-awesome-icon class="icon" role="none" :icon="['far', 'chevron-right']" :style="{ color: iconColor }" />
        <div class="sr-only">Next</div>
      </template>
    </agile>
    <agile
      v-if="displayThumbnails"
      class="thumbnails mt-3"
      ref="thumbnails"
      :options="thumbnailsOption"
      :as-nav-for="asNavigationForThumbnails"
    >
      <div
        class="slide slide--thumbnail"
        v-for="(slide, index) in imageList"
        :key="index"
        :class="`slide--${index}`"
        @click="$refs.thumbnails.goTo(index)"
      >
        <img :src="slide" :alt="`Thumbnail Image ${index}`" />
      </div>
    </agile>
  </div>
</template>

<script>
import { VueAgile } from 'vue-agile';

export default {
  name: 'ImageCarousel',
  components: {
    // Infinite scroll has a bug that shows duplication images for low number of images
    agile: VueAgile,
  },
  props: {
    imageList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isInitiated: false,
      iconColor: '#ffffff',
      asNavigationForMain: [],
      asNavigationForThumbnails: [],
      mainOptions: {
        dots: false,
        fade: true,
        navButtons: true,
        infinite: false,
      },
      thumbnailsOption: {
        infinite: false,
        dots: false,
        navButtons: false,
        slidesToShow: 4,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 6,
            },
          },
        ],
      },
    };
  },
  computed: {
    displayThumbnails() {
      return this.imageList.length > 1;
    },
  },
  mounted() {
    this.asNavigationForMain.push(this.$refs.thumbnails);
    this.asNavigationForThumbnails.push(this.$refs.main);
    this.isInitiated = true;
    window.addEventListener('keyup', this.keyboardNavigation);
  },
  destroyed() {
    window.removeEventListener('keyup', this.keyboardNavigation);
  },
  methods: {
    reloadCarousel() {
      this.$refs.main.reload();
      this.$refs.thumbnails.reload();
    },
    keyboardNavigation(event) {
      switch (event.key) {
        case 'ArrowLeft':
          this.$refs.main.goToPrev();
          break;
        case 'ArrowRight':
          this.$refs.main.goToNext();
          break;
        default:
      }
    },
  },
  watch: {
    imageList() {
      if (this.isInitiated) {
        this.reloadCarousel();
      }
    },
  },
};
</script>

<style lang="scss">
.main-carousel .agile__actions {
  .agile__nav-button {
    position: absolute;
    bottom: 0;
    height: 100%;
    background-color: #0000000f;
    border: none;

    &.agile__nav-button--next {
      right: 0;
    }

    &[disabled] {
      display: none;
    }

    &:focus,
    &:hover {
      background-color: #ffffff9e;
    }

    .icon {
      font-size: 40px;
    }
  }
}
</style>

<style scoped lang="scss">
@import 'src/assets/scss/variables';

.image-carousel {
  max-width: 600px;
  margin: 0 auto;
}

.thumbnails {
  margin: 0 -5px;

  .agile__slide--current.agile__slide--active img {
    border: 2px solid $primary;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }
}

.slide {
  align-items: center;
  box-sizing: border-box;
  color: #fff;
  display: flex;
  height: 450px;
  justify-content: center;
}

.slide--thumbnail {
  cursor: pointer;
  height: 80px;
  padding: 0 5px;
  transition: opacity 0.3s;
}

.slide--thumbnail:hover {
  opacity: 0.75;
}

.slide img {
  height: 100%;
  object-fit: cover;
  object-position: center;
  width: 100%;
  border-radius: 4px;
}

@media only screen and (max-width: $breakpoint-mobile) {
  .thumbnails .slide--thumbnail {
    max-height: 61px;
  }

  .main-carousel .slide {
    max-height: 250px;
  }
}
</style>
